import { addDefaultFlagsToCloudinaryUrl } from '../HBMediaElement/HBMediaElement';

export const isPdfExtension = (extension: string) => {
    if (!extension) {
        return;
    }
    const regex = new RegExp('pdf', 'i');
    return regex.test(extension);
};

export const isPdfUrl = (url: string) => {
    // Remove query parameters to handle cases where a dot in the query string may break the extension check
    const cleanUrl = url.split('?')[0];
    return isPdfExtension(cleanUrl.split('.').pop());
};

const CLOUDINARY_PATH = '//res.cloudinary.com/honeybook/image/fetch';

export const generatePdfPreviewUrl = ({
    url,
    width,
    height
}: {
    url: string;
    width: number;
    height?: number;
}) => {
    return `${CLOUDINARY_PATH}/q_auto,dpr_2,w_${width},${
        height ? `h_${height},` : ''
    }f_auto,fl_lossy,c_fill/${url}`;
};

export const generatePdfThumbnailUrl = ({
    url,
    width,
    height
}: {
    url: string;
    width: number;
    height?: number;
}) => {
    return `${CLOUDINARY_PATH}/q_auto,dpr_3,w_${width},h_${height},c_thumb,f_auto,fl_lossy,c_fill,g_north/${url}`;
};

export const generateImageDownloadUrl = (url: string) => {
    return isCloudinaryImage(url)
        ? addDefaultFlagsToCloudinaryUrl(url, [{ flags: 'attachment' }])
        : url;
};

export const isCloudinaryImage = url =>
    url?.indexOf('res.cloudinary.com/honeybook') > -1;
